import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import { useHelpRequestsApi } from "../../http/useHelpRequests";
import SupportRequestDialog, { SupportRequestCapture } from "./SupportRequestDialog";

interface HelpRequestDialogProps extends SupportRequestCapture {
  onClose: () => void;
}

/** Help request of the end users, sent to the technical consulting team. */
const HelpRequestDialog: FC<HelpRequestDialogProps> = ({ screenshot, diagnostics, onClose }) => {
  const i18n = useI18n();
  const helpRequestsApi = useHelpRequestsApi();

  return (
    <SupportRequestDialog
      texts={{
        title: i18n.translation.helpRequests.dialogTitle,
        intro: i18n.translation.helpRequests.intro,
        success: i18n.translation.helpRequests.success,
      }}
      send={helpRequestsApi.sendHelpRequest}
      screenshot={screenshot}
      diagnostics={diagnostics}
      onClose={onClose}
    />
  );
};

export default HelpRequestDialog;
